module.exports = function () {
  return new Worker(__webpack_public_path__ + "d8a3cd18d32717755709.worker.js");
};